import React, { useState } from 'react';

/**
 * Isolated input form component for chat messages.
 * By managing prompt state locally, we avoid re-rendering the entire modal on each keystroke.
 */
function ChatInputForm({ onSendMessage, isLoading, useReference }) {
  const [prompt, setPrompt] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!prompt.trim() || isLoading) return;
    onSendMessage(prompt);
    setPrompt('');
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 border-t border-gray-200">
      <div className="flex gap-2">
        <input
          type="text"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder={
            useReference 
              ? "e.g., Remove the background, Make it brighter..."
              : "e.g., A delicious burger on a wooden table..."
          }
          disabled={isLoading}
          className="
            flex-1 px-4 py-2
            border border-gray-300
            rounded-lg
            focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent
            disabled:bg-gray-100 disabled:cursor-not-allowed
          "
        />
        <button
          type="submit"
          disabled={!prompt.trim() || isLoading}
          className="
            px-6 py-2
            bg-purple-500 hover:bg-purple-600
            disabled:bg-gray-300 disabled:cursor-not-allowed
            text-white font-medium
            rounded-lg
            transition-colors
            flex items-center gap-2
          "
        >
          {isLoading ? (
            <>
              <div className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full"></div>
              Generating...
            </>
          ) : (
            <>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
              </svg>
              Send
            </>
          )}
        </button>
      </div>
    </form>
  );
}

export default ChatInputForm;
